<template>

    <div>
        <div class="container-fluid">
            <div class="page-title">
                <h4>Mes Invitations</h4>
            </div>
             <div class="row">
                <div class="col-md-10 m-auto">
                            <mes-invitations class="mt-4"> </mes-invitations>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>

    import api from "../config/_api";
    import Role from "../components/Role/Role.vue";
    

export default {
        name: "Role",
        components: { 
            'mes-invitations' : Role},
        data() {
            return {
                
            }
             
        },
    created() {
        this.token=this.$route.params.token;

    },
        methods : {
            
        }
    
}
</script>